/** @internal */
export const OP_BOTH_RUNNING = "BothRunning" as const

/** @internal */
export type OP_BOTH_RUNNING = typeof OP_BOTH_RUNNING

/** @internal */
export const OP_LEFT_DONE = "LeftDone" as const

/** @internal */
export type OP_LEFT_DONE = typeof OP_LEFT_DONE

/** @internal */
export const OP_RIGHT_DONE = "RightDone" as const

/** @internal */
export type OP_RIGHT_DONE = typeof OP_RIGHT_DONE
